/* ---------- MOVE FUNCTION ---------- */

function moveSternifyElements() {

  const bundles = document.querySelectorAll(".st_variantbundle-box");

  if (!bundles.length) return;

  bundles.forEach((box) => {

    const titleWrapper = box.querySelector(".st_input-title-wrapper");
    const title = box.querySelector(".st_input-title");
    const productsContainer = box.querySelector(".st_products-container");

    const label = box.querySelector(".st_input-label");
    const highlighted = box.querySelector(".st_input-highlighted-tag");

    const priceWrapper = box.querySelector(".st_price-wrapper");

    /*if (!titleWrapper || !title) return;*/

    /* -------- CHECK TEXT EMPTY -------- */

    if (label) {
      if (label.textContent.trim() === "") {
        label.classList.add("no-text");
      } else {
        label.classList.remove("no-text");
      }
    }

    if (highlighted) {
      if (highlighted.textContent.trim() === "") {
        highlighted.classList.add("no-text");
      } else {
        highlighted.classList.remove("no-text");
      }
    }

    /* -------- CREATE WRAPPER -------- */

    /*let customWrap =
      titleWrapper.querySelector(".st_custom-products-wrap");

    if (!customWrap) {

      customWrap = document.createElement("div");
      customWrap.className = "st_custom-products-wrap";

      const customTitle = document.createElement("div");
      customTitle.className = "st_custom-products-title";

      customTitle.textContent =
        window.whatsIncludedText || "What's included?";

      customWrap.appendChild(customTitle);

      title.insertAdjacentElement(
        "afterend",
        customWrap
      );

    }*/

    /* -------- MOVE PRODUCTS -------- */

    /*const customTitle =
      customWrap.querySelector(".st_custom-products-title");

    if (
      productsContainer &&
      customTitle &&
      productsContainer.parentElement !== customWrap
    ) {
      customWrap.insertBefore(
        productsContainer,
        customTitle
      );
    }*/

    /* -------- MOVE LABEL -------- */

    if (
      label &&
      priceWrapper &&
      !priceWrapper.contains(label)
    ) {
      priceWrapper.appendChild(label);
    }

    /* -------- MOVE HIGHLIGHT -------- */

    /*if (
      highlighted &&
      priceWrapper &&
      !priceWrapper.contains(highlighted)
    ) {
      priceWrapper.appendChild(highlighted);
    }*/

  });

}


/* ---------- WAIT UNTIL BUNDLE LOAD ---------- */

function waitForBundleAndObserve() {

  const bundleRoot =
    document.querySelector("#sternify-variant-bundle");

  /* Nếu đã load */
  if (bundleRoot) {

    moveSternifyElements();
    observeBundleChanges(bundleRoot);

    return;
  }

  /* Nếu chưa load */
  const observer = new MutationObserver((_, obs) => {

    const bundleRoot =
      document.querySelector("#sternify-variant-bundle");

    if (bundleRoot) {

      obs.disconnect();

      moveSternifyElements();
      observeBundleChanges(bundleRoot);

    }

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

}


/* ---------- OBSERVE ONLY BUNDLE ---------- */

function observeBundleChanges(bundleRoot) {

  const observer = new MutationObserver(() => {

    moveSternifyElements();

  });

  observer.observe(bundleRoot, {
    childList: true,
    subtree: true,
  });

}


/* ---------- START ---------- */

document.addEventListener(
  "DOMContentLoaded",
  waitForBundleAndObserve
);